module.exports = __webpack_public_path__ + "img/postfinancelogo.b716f6da.png";